<template>

    <div id="myChart_clf" style="height: 440px"></div>
</template>
<script>
    import * as echarts from 'echarts';
	import axios from 'axios';
	import config from "@/config";
    var option;
    var systemDate;
	const base_url = config.baseUrl + 'spf/';
    export default {
        name: 'clf_echats',
        data () {
            return {
                msg: 'Welcome use Echarts'
            }
        },
        mounted(){
			axios.get(base_url + "j30tclfcjhq").then(response => this.drawLine(response.data)).catch(error => console.log(error, "error"));
        },
        methods: {
            drawLine(data){
                // 基于准备好的dom，初始化echarts实例
                let myChart_clf = echarts.init(document.getElementById('myChart_clf'));
                let systemDate = this.addDate();
                var fontSize = 18;
                var maxmj = data.maxmj==0?250:data.maxmj+100;
                var maxts = data.maxts==0?25:data.maxts+5;
                var floatStyle='center';
                if( /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ) {//如果是移动端修改Echarts参数
                    // 执行相应代码或直接跳转到手机页面
                    fontSize=12;
                    floatStyle='right';
                }
                option = {
                    title: {
                        // text: '日期  '+this.timeForMat(30,'yyyy年-mm月-dd日')+"-"+this.timeForMat(1,'yyyy年-mm月-dd日'),
						text: '日期 ' + data.rqqj,
                        left: '0%',
                        textStyle: {
                            color: '#333333',
                            fontWeight: 'bold',
                            fontSize: fontSize
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        }
                    },
                    grid: {
                        left: '1%',
                        right: '0',
                        bottom: '1%',
                        containLabel: true
                    },
                    toolbox: {
                        feature: {
                            dataView: {show: false, readOnly: false},
                            magicType: {show: false, type: ['line', 'bar']},
                            restore: {show: false},
                            saveAsImage: {show: false}
                        }
                    },
                    legend: {
                        /*icon:"circle",*/
                        itemWidth: 13,  // 设置宽度
                        /*itemHeight: 30, // 设置高度
                        itemGap: 60, // 设置间距*/
                        data: [ '套数','面积'],
                        left: floatStyle,
                        textStyle: {
                            color: '#00448C',
                            fontWeight: 'bold',
                            fontSize: fontSize
                        },

                    },
                    xAxis: [
                        {
                            type: 'category',
                            // data: this.getDateArray(),
							data: data.rq,
                            axisPointer: {
                                type: 'shadow'
                            },
                            axisLabel: {    //底部文字倾斜
                                rotate:40,
                            },


                        },
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            name: '套数',
                            min: 0,
                            max: maxts,
                            interval: maxts/5,
                            axisLabel: {
                                formatter: '{value}'
                            }
                        },
                        {
                            type: 'value',
                            name: '面积',
                            min: 0,
                            max: maxmj,
                            interval: maxmj/10,
                            axisLabel: {
                                formatter: function (value) {
                                    if(value==0){
                                        return value;
                                    }else{
                                        return value.toFixed(3);
                                    }
                                }
                            }
                        }
                    ],
                    series: [
                        {
                            name: '套数',
                            type: 'line',
                            yAxisIndex: 0,
                            symbolSize: 8,
                            // data: [14, 15, 11, 6, 11, 10, 20, 23, 23, 16, 12, 6,11,5,12,14, 15, 11, 6, 11, 10, 20, 23, 23, 16, 12, 6,11,5,12],
							data: data.ts,
                            itemStyle : {
                                normal : {
                                    color: "#F56D38",
                                    lineStyle:{
                                        color:'#F56D38'
                                    },
                                }
                            },
                        },
                        {
                            name: '面积',
                            type: 'bar',
                            yAxisIndex: 1,
                            barMaxWidth:15,
                            // data: [2.6, 5.9, 9.0, 26, 28.7, 70.7, 175.6, 182.2, 18.7, 18.8, 6.0, 2.3,2.6, 5.9, 9.0, 26, 28.7, 70.7, 175.6, 182.2, 18.7, 18.8, 6.0, 2.3,12,23,21,12,11,23],
							data: data.mj,
                            itemStyle : {
                                normal : {
                                    color: "#386CF0",
                                }
                            },
                        }
                    ]
                };
                // 绘制图表
                window.onresize = myChart_clf.resize;
                myChart_clf.setOption(option);
            },
            addDate() {
                var nowDate = new Date();
                let date = {
                    year: nowDate.getFullYear(),
                    month: nowDate.getMonth() + 1,
                    date: nowDate.getDate(),
                }
                var systemDate = date.year + '-'  + (date.month >= 10 ? date.month : '0' + date.month) + '-'  + (date.date >= 10 ? date.date : '0'+ date.date);
                //let systemDate = date.year + '-' + 0 + date.month + '-' + 0 + date.date;
                //返回天数数字
                var dateArray=new Array();
                return systemDate;
            },
            timeForMat (count,type) {
                // 拼接时间
                let time1 = new Date()
                time1.setTime(time1.getTime() - (24 * 60 * 60 * 1000))
                let Y1 = time1.getFullYear()
                let M1 = ((time1.getMonth() + 1) > 10 ? (time1.getMonth() + 1) : '0' + (time1.getMonth() + 1))
                let D1 = (time1.getDate() > 10 ? time1.getDate() : '0' + time1.getDate())
                let timer1 = Y1 + '-' + M1 + '-' + D1 // 当前时间
                let time2 = new Date()
                time2.setTime(time2.getTime() - (24 * 60 * 60 * 1000 * count))
                let Y2 = time2.getFullYear()
                let M2 = ((time2.getMonth() + 1) > 9 ? (time2.getMonth() + 1) : '0' + (time2.getMonth() + 1))
                let D2 = (time2.getDate() > 9 ? time2.getDate() : '0' + time2.getDate())
                // let timer2 = Y2 + '-' + M2 + '-' + D2 // 之前的7天或者30天
                // return {
                // // t1: timer1,
                // // t2: timer2
                // }
                if(type=='yyyy年-mm月-dd日'){
                    return Y2 + '年' + M2 + '月' + D2+'日' ;
                }else{
                    return M2 + '-' + D2 ;
                }
                return M2 + '-' + D2 ;
            },
            getDateArray(){
                var dateArray=new Array()
                dateArray[0]=new Date().getFullYear() + '-' +this.timeForMat(30,'mm-dd');
                for (var i=1;i<30;i++){
                    dateArray[i]=this.timeForMat(30-i,'mm-dd');
                }
                return dateArray;
            }
        },
    }
</script>